<template>
  <pt-balance-manage class="pt-balance-manage__withData" :departmentList="departmentList" v-loading="loading" :balanceTotal="balanceTotal" @getDepartmentBalance="getDepartmentBalance" :balanceList="balanceList" @enterAmountSuc="enterAmountSuc"></pt-balance-manage>
</template>

<script>
import { cashCount } from '@/utils/formUtils'
import PtBalanceManage from './index'
export default {
  name: 'pt-balance-manage__withData',
  components: {
    'pt-balance-manage': PtBalanceManage
  },
  data () {
    return {
      departmentList: [],
      loading: false,
      balanceList: [],
      balanceTotal: ''
    }
  },
  methods: {
    enterAmountSuc () {
      this.getAllDepartmentBalance()
      this.getDepartmentBalance()
    },
    getDepartmentList () {
      this.$store.dispatch('getBusinessDepartment').then(res => {
        var newArr = []
        res.forEach(ele => {
          var obj = {}
          let val = {
            id: ele.id,
            name: ele.name
          }
          obj.value = JSON.stringify(val)
          obj.label = ele.name
          newArr.push(obj)
        })
        this.departmentList = newArr
      }).catch(err => {
        this.loading = false
        this.$message(err || '获取事业部列表失败')
      })
    },
    getDepartmentBalance () {
      this.$store.dispatch('getEachBusinessDepartmentQuota').then(res => {
        res.forEach(e => {
          e.quota = cashCount(e.quota, true)
        })
        this.balanceList = res
      }).catch(err => {
        this.loading = false
        this.$message(err || '获取事业部额度失败')
      })
    },
    getAllDepartmentBalance () {
      this.$store.dispatch('getAllDepartmentBalance').then(res => {
        this.balanceTotal = cashCount(res, true)
      }).catch(err => {
        this.loading = false
        this.$message(err || '获取事业部总额度失败')
      })
    }
  },
  created () {
    this.getDepartmentBalance()
    this.getDepartmentList()
    this.getAllDepartmentBalance()
  }
}
</script>
